<i class="icon-gear icon-spin"></i>
<ng-content></ng-content>
